import { IThuPhiTheoLopTab } from "./../../../model/request/thu-phi/IThuPhiTheoLopTab";

import { ITreeviewLopFocusedValue } from "../../../components-data/treeview-lop/TreeviewLop";
import { IBienLaiThuTheoLopCreateRequest } from "../../../model/request/bien-lai/IBienLaiThuTheoLopCreateRequest";
import { IMucThuKhacSinhVienTheoLopSelectRequest } from "../../../model/request/chung-tu/IMucThuKhacSinhVienTheoLopSelectRequest";
import { IBienLaiThuHinhThucNopViewModel } from "../../../model/respone/chung-tu/IBienLaiThuHinhThucNopViewModel";
import { IMucThuKhacSinhVienViewModel } from "../../../model/respone/chung-tu/IMucThuKhacSinhVienViewModel";
import { generateActionTypeIds } from "../generateActionTypeIds";
import IGenericActionType from "../IGenericActionType";
export interface IThuPhiTheoLopTabActionTyes<T> {
  request: IMucThuKhacSinhVienTheoLopSelectRequest;
  data: T;
  other?: any;
}

export interface IThuPhiTheoLopByIdTabActionTyes<T> {
  tabId: string;
  data: T;
  other?: any;
}

export const eThuPhiTheoLopActionsObj = {
  ADD_NEW_TAB: undefined,
  REMOVE_TAB: "",
  UPDATE_TAB_DATA: {} as IThuPhiTheoLopTab,
  CHANGEG_SELECTED_TAB: "",

  LOAD_MUC_THU_KHAC_START: {} as IMucThuKhacSinhVienTheoLopSelectRequest,
  LOAD_MUC_THU_KHAC_SUCCESS: {} as IThuPhiTheoLopTabActionTyes<
    IMucThuKhacSinhVienViewModel[]
  >,
  LOAD_MUC_THU_KHAC_ERROR: {} as IThuPhiTheoLopTabActionTyes<string>,

  CHANGE_LOP_SELECTED:
    {} as IThuPhiTheoLopByIdTabActionTyes<ITreeviewLopFocusedValue>,

  CHANGE_LOAI_THU_CHI_SELECTED: {} as IThuPhiTheoLopByIdTabActionTyes<number>,

  CHANGE_SINH_VIEN_SELECTED_IDs: {} as IThuPhiTheoLopTabActionTyes<string[]>,
  CHANGE_STEP: {} as IThuPhiTheoLopTabActionTyes<number>,
  CHANGE_HINHTHUCNOP: {} as IThuPhiTheoLopTabActionTyes<
    IBienLaiThuHinhThucNopViewModel[]
  >,

  CHANGE_SO_TIEN_THUC_NOP: {} as IThuPhiTheoLopTabActionTyes<number>,

  CREATE_BIENLAITHU_START: {} as IBienLaiThuTheoLopCreateRequest,
  CREATE_BIENLAITHU_SUCCESS: {} as IThuPhiTheoLopTabActionTyes<number>,
  CREATE_BIENLAITHU_ERROR: {} as IThuPhiTheoLopTabActionTyes<string>,
  CHANGE_THONGTINBIENLAI: {} as IThuPhiTheoLopTabActionTyes<any>,
};
export const eThuPhiTheoLopActionIds = generateActionTypeIds(
  eThuPhiTheoLopActionsObj,
  "THU_PHI_THEO_LOP"
);
export type IThuPhiTheoLopActionTypes = IGenericActionType<
  typeof eThuPhiTheoLopActionsObj,
  "THU_PHI_THEO_LOP"
>;
